import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { LoginModel } from 'src/app/models/commModel';
import { AccountService } from 'src/app/services/account.service';
import { ResourceService } from 'src/app/services/resource.service';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from 'src/app/shared/guards/auth.service';
import { SSOService } from 'src/app/services/sso.service';

@Component({
  selector: 'app-signin-popup',
  templateUrl: './signin-popup.page.html',
  styleUrls: ['./signin-popup.page.scss'],
})

export class SigninPopupPage implements OnInit {

  public LoginId: any;
  public Password: any;
  FACode: any;
  disableGen2FA = true;


  constructor(private modalCtrl: ModalController, private router: Router, private accountService: AccountService,
    private resourceService: ResourceService, private userSerivce: UserService, private authService: AuthService,
    private ssoService: SSOService) { }
  ngOnInit(): void {
    // throw new Error('Method not implemented.');
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  confirm() {
    if (this.userSerivce.GoToBooking) {
      this.userSerivce.GoToBooking = false;
      this.resourceService.GoToBooking();
    }

    return this.modalCtrl.dismiss(true, 'confirm');
  }

  CheckGen2FAEnable() {
    if ((this.Password && this.LoginId) || !this.disableGen2FA) {
      return false;
    }
    return true;
  }

  CheckSignInEnable() {
    if (this.FACode && this.Password && this.LoginId) {
      return false;
    }
    return true;
  }

  Gen2FA() {
    var m = new LoginModel();
    m.LoginId = this.LoginId;
    m.Password = this.Password;

    this.resourceService.showLoading(true);
    this.accountService.Get2FA(m).subscribe(r => {
      this.resourceService.showLoading(false);
      this.resourceService.openSnackBar("emailSent");
      this.disableGen2FA = true;
      setTimeout(() => {
        this.disableGen2FA = false;
      }, 3000)

    },
      error => {
        this.resourceService.openExceptionSnackBar(error);
        this.resourceService.showLoading(false);
      }
    );
  }

  SignIn() {
    this.resourceService.showLoading(true);
    var loginModel = new LoginModel();
    loginModel.LoginId = this.LoginId;
    loginModel.Password = this.Password;
    loginModel.FACode = this.FACode;
    this.accountService.UserLogin(loginModel).subscribe(data => {
      this.resourceService.showLoading(false);
      this.authService.login(data.UserId, data.RowId, data.UserName, data.Token, false);
      this.confirm();
    },
      error => {
        this.resourceService.openExceptionSnackBar(error);
        this.resourceService.showLoading(false);
      }
    );
  }


  Login() {
    this.resourceService.showLoading(true);
    this.ssoService.CheckLogin().subscribe(u => {
      if (u) {
        var loginModel = new LoginModel();
        loginModel.adfs = u.adfs;
        loginModel.adfsId = u.adfsId;
        loginModel.timestamp = u.timestamp
        this.accountService.UserLogin(loginModel).subscribe(data => {
          this.resourceService.showLoading(false);
          this.authService.login(data.UserId, data.RowId, data.UserName, data.Token, true);
          this.confirm();
        },
          error => {
            this.resourceService.openExceptionSnackBar(error);
            this.resourceService.showLoading(false);
          }
        );
      }
      else {
        var externalWindow = window.open(this.ssoService.LoginHref(), '', "width=" + screen.availWidth + ",height=" + screen.availHeight);
        var timer = setInterval(() => {
          if (externalWindow && externalWindow.closed) {
            clearInterval(timer);
            this.resourceService.showLoading(false);
            this.ssoService.CheckLogin().subscribe(u => {
              if (u) {
                var loginModel = new LoginModel();
                loginModel.adfs = u.adfs;
                loginModel.adfsId = u.adfsId;
                loginModel.timestamp = u.timestamp
                this.accountService.UserLogin(loginModel).subscribe(data => {
                  this.resourceService.showLoading(false);
                  this.authService.login(data.UserId, data.RowId, data.UserName, data.Token, true);
                  this.confirm();
                },
                  error => {
                    this.resourceService.openExceptionSnackBar(error);
                    this.resourceService.showLoading(false);
                  }
                );
              }
              else {
                this.resourceService.openFailSnackBar("loginFail");
              }
            },
              error => {
                this.resourceService.showLoading(false);
              }
            );
          }
        }, 1000);
      }
    },
      error => {
        this.resourceService.showLoading(false);
      }
    );
  }

}